// extracted by mini-css-extract-plugin
module.exports = {"gradeRow":"_2gSfAAB","reviewsFilterGradeIndicator":"cZaLGp5","ratingContainer":"zlLUJOP","reviewsFilterLabel":"HgBbTmX","concise":"EpMJeGA"};